<style scoped>
.symbol-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}
.orders-table-header {
  border-bottom: 1px solid var(--color-border);
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 5px;
  text-align: left;
  font-size: 12px;
  color: var(--color-text-dark);
}
.orders-table {
  border-collapse: collapse;
  width: 96%;
  margin-bottom: 20px;
  margin-left: 15px;
  font-size: 12px;
}
.tablerow {
  height: 32px;
}
.clickable {
  cursor: pointer;
}
.right-padding {
  padding-right: 5px;
}
.row:hover {
  background-color: var(--color-background);
  cursor: pointer;
}
</style>

<template>
  <Modal
    :value="$store.state.openOrdersModal.show"
    width="800"
    @input="$emit('on-cancel', $event)"
  >
    <div
      slot="header"
      style="text-align: center; font-weight: bold"
    >{{ $text.tr('ОРДЕРА НА БИРЖЕ') }} <span v-if="$store.state.openOrdersModal.openOrders.length > 0" style="color: #787bb4;">[{{ $store.state.openOrdersModal.openOrders.length }}]</span></div>
    <table class="orders-table">
      <tr>
        <th class="orders-table-header">
          <span
            class="clickable noselect"
            @click="sortList('coin')"
          >{{ $text.tr('ПАРА') }}</span>
          <Icon
            v-if="sort.field === 'coin' && sort.direction === 1"
            color="var(--color-text-dark)"
            type="md-arrow-dropup"
          />
          <Icon
            v-if="sort.field === 'coin' && sort.direction === -1"
            color="var(--color-text-dark)"
            type="md-arrow-dropdown"
          />
        </th>
        <th class="orders-table-header">
          <span
            class="clickable noselect"
            @click="sortList('date')"
          >{{ $text.tr('ДАТА') }}</span>
          <Icon
            v-if="sort.field === 'date' && sort.direction === 1"
            color="var(--color-text-dark)"
            type="md-arrow-dropup"
          />
          <Icon
            v-if="sort.field === 'date' && sort.direction === -1"
            color="var(--color-text-dark)"
            type="md-arrow-dropdown"
          />
        </th>
        <th class="orders-table-header">
          <span
            class="clickable noselect"
            @click="sortList('side')"
          >{{ $text.tr('НАПРАВЛЕНИЕ') }}</span>
          <Icon
            v-if="sort.field === 'side' && sort.direction === 1"
            color="var(--color-text-dark)"
            type="md-arrow-dropup"
          />
          <Icon
            v-if="sort.field === 'side' && sort.direction === -1"
            color="var(--color-text-dark)"
            type="md-arrow-dropdown"
          />
        </th>
        <th class="orders-table-header noselect">{{ $text.tr('КОЛ-ВО') }}</th>
        <th class="orders-table-header noselect">{{ $text.tr('ЦЕНА') }}</th>
        <th class="orders-table-header noselect">{{ $text.tr('СУММА') }}</th>
        <th class="orders-table-header">
          <span
            class="clickable noselect"
            @click="sortList('type')"
          >{{ $text.tr('ТИП') }}</span>
          <Icon
            v-if="sort.field === 'type' && sort.direction === 1"
            color="var(--color-text-dark)"
            type="md-arrow-dropup"
          />
          <Icon
            v-if="sort.field === 'type' && sort.direction === -1"
            color="var(--color-text-dark)"
            type="md-arrow-dropdown"
          />
        </th>
      </tr>
      <template v-for="(order) in ordersList">
        <tr
          :key="order.Id"
          class="tablerow row"
          @click="selectOrder(order)"
        >
          <td
            class="right-padding"
            style="font-weight: bold"
          >
            <div class="symbol-wrapper">
              <CoinIcon :symbol="returnSymbol(order.Symbol)" />
              <span>{{ returnSymbol(order.Symbol) }}</span>
            </div>
          </td>
          <td class="right-padding">
            {{ localTime(order.Updated) }}
          </td>
          <td class="right-padding">
            <div
              v-if="order.Side === 'B'"
              style="color: var(--color-success-light)"
            >{{ $text.tr('ПОКУПКА') }}</div>
            <div
              v-if="order.Side === 'S'"
              style="color:var(--color-danger-light)"
            >{{ $text.tr('ПРОДАЖА') }}</div>
          </td>
          <td class="right-padding">
            <div v-if="order.Filled > 0">{{ order.Filled }} / {{ order.Qty }}</div>
            <div v-else>{{ order.Qty }}</div>
          </td>
          <td class="right-padding">
            {{ order.Price }}
          </td>
          <td class="right-padding">
            {{ returnAmount(order.Qty, order.Price) }}
          </td>
          <td>
            <div
              v-if="order.TradeId !== ''"
              style="color: mediumpurple; cursor: pointer"
              @click="$copyToClipboardAndNotify(order.TradeId)"
            >TRADE #{{ order.TradeId }}</div>
            <div
              v-if="order.BotId !== ''"
              style="color: dodgerblue; cursor: pointer"
              @click="$copyToClipboardAndNotify(order.BotId)"
            >BOT #{{ order.BotId }}</div>
          </td>
        </tr>
      </template>
    </table>
    <div slot="footer"></div>
  </Modal>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Smartlimit } from '../../util/types'
import Decimal from 'decimal.js'
// @ts-ignore
import terminal from '@/services/terminal'
// @ts-ignore
import Bots from '@/services/bots'
// @ts-ignore
import BotApi from '@/util/botapi'
import CoinIcon from './CoinIcon.vue'

export interface Sort {
  direction: number
  field: string
}

@Component({
  components: {
    CoinIcon
  }
})
export default class OpenOrdersModal extends Vue {
  // @Prop() private show!: boolean;
  // @Prop() private orders!: Smartlimit[];
  sort: Sort = {
    direction: -1,
    field: 'date'
  }

  get ordersList () {
    const list: Smartlimit[] = []
    // @ts-ignore
    this.$store.state.openOrdersModal.openOrders.forEach((item) => {
      list.push(item)
    })
    list.sort((a: Smartlimit, b: Smartlimit) => {
      return new Date(a.Updated).getTime() - new Date(b.Updated).getTime()
    })
    list.sort((a: Smartlimit, b: Smartlimit) => {
      let direction = 1
      switch (this.sort.field) {
        case 'coin':
          direction = a.Symbol > b.Symbol ? 1 : -1
          break
        case 'date':
          // direction = new Date(b.Updated).getTime() - new Date(a.Updated).getTime()
          break
        case 'side':
          direction = a.Side > b.Side ? 1 : -1
          break
        case 'type':
          direction = a.BotId !== '' ? 1 : -1
      }
      return this.sort.direction * direction
    })
    return list
  }

  selectOrder (order: Smartlimit) {
    if (order.BotId !== '') {
      // @ts-ignore
      if (this.$route.name === 'terminal') {
        // @ts-ignore
        this.$router.push('/bots')
      }
      Bots.SelectBotSymbol(order.Symbol)
      // @ts-ignore
      this.$store.state.bots.editMode = true
      const ref = this
      BotApi.get('bot/list', {
        params: {
          // @ts-ignore
          token: this.$store.state.sys.token,
          // @ts-ignore
          etid: this.$store.state.sys.tradeExchange.Id,
          status: 'act',
          // @ts-ignore
          symbol: this.$store.state.bots.symbol
        }
      }).then(function (response: any) {
        // console.log(JSON.stringify(response.data))
        if (response.data !== null) {
          if (!response.data.err) {
            // ok
            if (response.data) {
              // @ts-ignore
              // ref.$store.state.bots.activeBotsList = response.data
              // @ts-ignore
              response.data.forEach((bot: any) => {
                // console.log('bot', bot.Id)
                if (order.BotId === bot.Id) {
                  // console.log('bot matched', bot.Id)
                  // @ts-ignore
                  ref.$store.state.bots.editBot = bot
                }
              })
            }
          }
        }
      }).catch(function (error: string) {
        // error
        console.log(error)
      })
    }
    if (order.TradeId !== '') {
      // @ts-ignore
      if (this.$route.name === 'bots') {
        // @ts-ignore
        this.$router.push('/terminal')
      } else {
        this.$store.state.trades.choosenTradeIndex = -1
      }
      // @ts-ignore
      if (!this.$store.state.trade.tvEnabled) {
        // @ts-ignore
        this.$store.state.trade.showTV = true
        setTimeout(() => {
          terminal.tradeGetAndSet(order.TradeId)
        }, 3000)
      } else {
        // @ts-ignore
        this.$store.state.trade.showTV = true
        terminal.tradeGetAndSet(order.TradeId)
      }
      terminal.selectSymbol(order.Symbol)
    }
    // @ts-ignore
    this.$store.state.openOrdersModal.show = false
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }

  localTime (utctime: string) {
    return new Date(utctime).toLocaleString('ru-RU').replace(',', '')
  }

  returnAmount (qty: number, price: number) {
    const amount = new Decimal(qty).mul(new Decimal(price)).toDP(8).toString()
    return amount
  }

  returnSymbol (symbol: string) {
    const assets = symbol.split('_')
    return assets[0] + '/' + assets[1]
  }

  sortList (field: string) {
    this.sort.field = field
    this.sort.direction = -1 * this.sort.direction
  }
}
</script>
